export const formatProductsBySku = (products: any[]) => products.reduce((acc, cur) => ({ ...acc, [cur.sku]: cur }), {});
